var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_6955_54340)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6955_54340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4004 10.3999C35.1197 10.3999 41.4004 16.6806 41.4004 24.3999C41.4004 32.1192 35.1197 38.3999 27.4004 38.3999C19.6811 38.3999 13.4004 32.1192 13.4004 24.3999C13.4004 16.6806 19.6811 10.3999 27.4004 10.3999ZM35.2246 18.7153C34.6632 18.1543 33.7859 18.1541 33.2246 18.7153L25.2246 26.7153L21.4707 23.2769C20.9093 22.7506 20.0322 22.7859 19.5059 23.3472C19.0146 23.9086 19.0499 24.7857 19.6113 25.312L24.3477 29.6284C24.9089 30.1545 25.7511 30.1192 26.2773 29.5933L35.2246 20.7153C35.786 20.1539 35.786 19.2767 35.2246 18.7153Z",
    fill: "url(#paint1_linear_6955_54340)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6955_54340",
    x: 0.400391,
    y: 3.3999,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6955_54340"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6955_54340",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6955_54340",
    x1: 25.4984,
    y1: -4.19688,
    x2: 0.310937,
    y2: 25.5812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAE04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263492,
    stopColor: "#A2DA55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528858,
    stopColor: "#78D967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765545,
    stopColor: "#6AD46B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FD478"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6955_54340",
    x1: 20.4069,
    y1: 8.89773,
    x2: 9.38173,
    y2: 32.2581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F9DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.706f7cf6933f5150af8bfb348b530bf5.svg";
export { ForwardRef as ReactComponent };